<div class="dtf-dashboard">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>
  <div *ngIf="!(this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
    <div class="demo-container">
      <span>{{ 'Invoice.Loading' | translate }}</span>
      <div class="progress-bar">
        <div class="progress-bar-value"></div>
      </div>
    </div>
  </div>

  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <!--US HTML page-->
  <div class="container_dashboard" *ngIf="!this.bodyLoaded  && !isCanadaPortal">
    <div class="row">
      <div class="col-sm-6">
        <div class="card1">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.YearlyHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Year-End_letter-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.YearlySubHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <div class="col-sm-6">
                <b for="customerNumber">Enter Account or Customer Number.<span 
                  style="margin-left: 8px; cursor: pointer;" 
                  title="Account number is a 13 digit number.Customer number is a 10 digit number">
                  ?
                </span></b> 
              
                <input class="form-control" type="text" name="ccanID" id="ccanID"
                [(ngModel)]="ccanID" required validateonblur value="" autocomplete="off" >
              </div>
            </div>
            <div class="row2">
              <mat-radio-group aria-labelledby="example-radio-group-label" style="display: block;" class="example-radio-group"
                [(ngModel)]="selectedYear">
                <mat-radio-button class="example-radio-button" *ngFor="let year of years" [value]="year">
                  {{year}}
                </mat-radio-button>
              </mat-radio-group>
              <!-- <div>Your favorite season is: {{selectedYear}}</div> -->
              <button class="mbfs-button" [disabled]="!selectedYear" (click)="retrieveInterestLetter(selectedYear)">{{
                'DocumentCenter.Download' | translate }}</button>
              <div *ngIf="!this.InterestFound">
                <h5 class="mbfs-modal-error" style="color: black;">{{this.InterestserviceErrorDesc}}<br></h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card1">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/View-Your-Invoices-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            </div>
         <div class="row2">
              <div class ="test2">
                <br><br><br>
                <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{
                  'LoginModal.Continue' | translate }}</button>
                  <br><br><br><br><br>
              </div>
            </div>
            <!-- <div class="row2">
            <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Invoice.Search' | translate }}</button>
            </div>  -->
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-6" *ngIf="isAdmin==='true'" >
        <div class="card1">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">Admin Portal</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Get-a-Payoff-Icon.png">
              <h4 class="dtfbrochures__header3">Admin Portal</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">Click here to Add / Modify Admins</p>
              <br>
                <button type="submit" (click)="checkUrl('admin')" class="mbfs-button">{{
                  'LoginModal.Continue' | translate }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card1">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">Change Password</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Get-a-Payoff-Icon.png">
              <h4 class="dtfbrochures__header3">Change Password</h4>
            </div>
            <div class="row2">
              <br><br><br>
              <br>
                <button type="submit" (click)="checkUrl('changepassword')" class="mbfs-button">{{
                  'LoginModal.Continue' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      
  </div>
  
  <div class="row">
    <div class="col-sm-6">
      <div class="card1">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">User Management</h4>
  
          <br>
          <br>
          <br>
  
          <div class="col-sm-8">
            <b>Enter in Affected Customer Number:</b>
            <br><br>
            <input class="form-control" type="text" name="customerNumber" id="customerNumber" [(ngModel)]="customerNumber"
              required value="customerNumber" autocomplete="off">
            <br>
            <button type="submit" (click)="checkUrl('mfa')" class="mbfs-button">{{
              'LoginModal.Continue' | translate }}</button>
          </div>
  
  
        </div>
      </div>
    </div>

    <div class="col-sm-6">
      <div class="card1">
        <div class="card-body1">
          <h4 class="dtfbrochures__title">Enable Line Item Payment</h4>
  
          <br>
          <br>
          <br>
  
          <div class="col-sm-8">
            <b>Enter in Affected Customer Number:</b>
            <br><br>
            <input class="form-control" type="text" name="customerNumber1" id="customerNumber1" [(ngModel)]="customerNumber1"
              required value="customerNumber1" autocomplete="off">
            <br>
            <button type="submit" (click)="lineItemPaymentEnable()" class="mbfs-button">Enable</button>
            <button type="submit" (click)="lineItemPaymentDisable()" class="mbfs-button">Disable</button>
          </div>

          <br><br>
          
          <div *ngIf="showmessage"
            style="color: black; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;"
          >
            {{ message }}
          </div>
  
        </div>
      </div>
    </div>
  </div>
  </div>
  
  